import shopProducts from './products.json';
export default shopProducts;
